export default __webpack_public_path__ + "static/media/settings (4).e650c2a1.svg";